import React, { useState, useEffect } from 'react';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import { useCurrency } from '../../Layouts/currencyContext';

const ItemlistGrid = ({ onRequisitionData, itemData, formData, SelectedIssue, fromlocation, currencyPrecision }) => {

    const apiService = new ApiService();
    const [rows, setRows] = useState([{
        requisitionNo: '',
        srno: '',
        recordId: '',
        ItemNo: '',
        itemDescription: '',
        specification: '',
        reqQty: '',
        uom: '',
        enteredQty: '',
        qty: '',
        balQty: '',
        amount: '',
        invQty: '',
        convRate: '',
        stock: '',
        unitPrice: '',
        cgsAcc: '',
        cgsAccName: '',
        expDate: '',
    }]);
    const [issueColumnWidths, setIssueColumnWidths] = useState({
        srNo: 80,
        itemNo: 120,
        description: 180,
        specification: 180,
        reqQty: 120,
        issueQty: 120,
        balQty: 120,
        inventoryUOM: 120,
        inventoryQty: 120,
        stock: 120,
        unitPrice: 120,
        amount: 140,
        cgsAcc: 120,
        cgsAccName: 180,
        expDate: 140
    });
    const totalAmount = rows.reduce((sum, row) => sum + (parseFloat(row?.amount) || 0), 0)
    const totalVatAmount = rows.reduce((sum, row) => sum + (parseFloat(row?.vatAmount) || 0), 0)
    useEffect(() => {
        if (formData?.requisitionNo?.label && fromlocation?.label) {
            getItems();
        }
    }, [formData, fromlocation]);
    const getItems = async () => {
        try {

            let param = `?RequisitionNo=${formData?.requisitionNo.label || formData?.requisitionNo}`
            if (itemData) {
                if (itemData.docno) {
                    const formattedRowsPromises = SelectedIssue?.issueDetails.map(async (detail, index) => {
                        const selecteditmstock = await apiService.getApiParamater('GET_ITEM_STORE', `?Warehouse=${formData?.fromLocation?.label}&itemNo=${detail?.itemCode}`);
                        let item = selecteditmstock?.data.result?.[0]
                        const getGLAccounts = await apiService.getApiParamater("GET_ITEM_GL", `?ItemNo=${detail.itemCode}`);
                        let glAccount = getGLAccounts?.data?.result[0]
                        return {
                            rsrno: detail?.rsrno,
                            ItemNo: detail.itemCode,
                            itemDescription: detail.itemDescription,
                            specification: detail.specification,
                            reqQty: item?.reqQty,
                            uom: detail.uom,
                            enteredQty: detail.qty,
                            balQty: item?.balQty,
                            amount: detail.unitPrice * detail.qty,
                            invQty: 1 * detail.qty,
                            convRate: item.convToInvUOM,
                            stock: item?.stock || 0,
                            unitPrice: detail.unitPrice || 0,
                            qty: item?.qty,
                            // qty: selectedReqItem?.qty,
                            cgsAcc: glAccount?.cgsAccountCode,
                            cgsAccName: glAccount?.cgsAccountName,
                            expDate: detail.expDate,
                        };
                    }).filter(row => row !== null);
                    const formattedRows = await Promise.all(formattedRowsPromises);
                    if (formattedRows.length > 0) {
                        setRows(formattedRows);
                        onRequisitionData(formattedRows);
                    }
                } else {
                    const response = await apiService.getApiParamater('GET_REQ_ITEM_ISSUE', param);
                    const formattedRowsPromises = itemData?.issueDetails.map(async (detail, index) => {
                        const selecteditmstock = await apiService.getApiParamater('GET_ITEM_STORE', `?Warehouse=${formData?.fromLocation?.label}&itemNo=${detail?.itemCode}`);
                        let item = selecteditmstock?.data?.result?.[0]
                        const selectedItem = response?.data?.result?.find((comp) => comp.itemCode === detail.itemCode && comp?.srno === detail?.rsrno);
                        const getGLAccounts = await apiService.getApiParamater("GET_ITEM_GL", `?ItemNo=${detail.itemCode}`);
                        let glAccount = getGLAccounts?.data?.result[0]
                        debugger
                        return {
                            rsrno: detail?.rsrno,
                            ItemNo: detail.itemCode,
                            itemDescription: detail.itemDescription,
                            specification: detail.specification,
                            reqQty: item?.reqQty,
                            uom: detail.uom,
                            enteredQty: detail.qty,
                            balQty: (selectedItem?.balQty + detail?.qty) || 0,
                            amount: detail.unitPrice * detail.qty || 0,
                            invQty: 1 * detail.qty,
                            convRate: item?.convToInvUOM,
                            stock: item?.stock || 0,
                            unitPrice: detail.unitPrice || 0,
                            qty: item?.qty,
                            cgsAcc: glAccount?.cgsAccountCode,
                            cgsAccName: glAccount?.cgsAccountName,
                            expDate: detail.expDate,
                        };
                    }).filter(row => row !== null);
                    const formattedRows = await Promise.all(formattedRowsPromises);
                    if (formattedRows.length > 0) {
                        setRows(formattedRows);
                        onRequisitionData(formattedRows);
                    }
                }
            } else {

                const response = await apiService.getApiParamater('GET_REQ_ITEM_ISSUE', param);
                const formattedRowsPromises = response.data.result?.map(async (detail, index) => {
                    const selecteditmstock = await apiService.getApiParamater('GET_ITEM_STORE', `?Warehouse=${formData?.fromLocation?.label}&itemNo=${detail?.itemCode}`);
                    let item = selecteditmstock?.data?.result?.[0]
                    const getGLAccounts = await apiService.getApiParamater("GET_ITEM_GL", `?ItemNo=${detail.itemCode}`);
                    let glAccount = getGLAccounts?.data?.result[0]
                    debugger
                    return {
                        rsrno: detail?.srno,
                        ItemNo: detail.itemCode,
                        itemDescription: detail.itemDescription,
                        specification: detail.specification,
                        reqQty: detail.reqQty,
                        uom: detail.uom,
                        enteredQty: detail.issueQty,
                        balQty: detail.balQty,
                        amount: detail.issueQty * item?.avgPrice,
                        invQty: 0,
                        convRate: item.convToInvUOM,
                        stock: item?.stock || 0,
                        unitPrice: item?.avgPrice || 0,
                        qty: detail.qty,
                        cgsAcc: glAccount?.cgsAccountCode,
                        cgsAccName: glAccount?.cgsAccountName,
                        expDate: detail.expDate,
                    };
                }).filter(row => row !== null);
                const formattedRows = await Promise.all(formattedRowsPromises);
                if (formattedRows.length > 0) {
                    setRows(formattedRows);
                    onRequisitionData(formattedRows);
                }
                // }
            }

        } catch (error) {
            console.error('Error fetching items:', error);
        }
    };
    const handleQtyChange = (index, value) => {
        // Always work with the latest rows state
        setRows(prevRows => {
            const newRows = [...prevRows];
            const selectedItem = newRows[index];
            debugger
            if (!selectedItem) {
                return prevRows;
            }

            // Allow empty value while typing / erasing
            if (value === "") {
                newRows[index] = {
                    ...selectedItem,
                    enteredQty: "",
                    amount: 0,
                    invQty: 0,
                };

                return newRows;
            }

            const newQty = Number(value);

            if (!Number.isFinite(newQty)) {
                return prevRows;
            }

            const balQty = Number(selectedItem.balQty ?? 0);
            const stock = Number(selectedItem.stock ?? 0);
            const unitPrice = Number(selectedItem.unitPrice ?? 0);

            if (newQty < 0) {
                toast.warning("Quantity cannot be less than 0.");
                return prevRows;
            }

            if (newQty > stock) {
                toast.warning(
                    `Enter a quantity less than or equal to the stock (${stock}).`
                );
                return prevRows;
            }

            if (newQty > balQty) {
                toast.warning(
                    `Enter a quantity less than or equal to the balance quantity (${balQty}).`
                );
                return prevRows;
            }

            // IMPORTANT:
            // Keep enteredQty in the actual rows state
            newRows[index] = {
                ...selectedItem,
                enteredQty: newQty,
                amount: newQty * unitPrice,
                invQty: newQty,
            };
            debugger
            onRequisitionData(newRows);
            return newRows;
        });
    };
    const handleDateChange = (index, expDate) => {
        const updatedRows = [...rows];
        updatedRows[index].expDate = expDate;
        const updatedSelectedRows = rows.map((row, i) =>
            i === index ? { ...row, expDate: expDate } : row
        );
        setRows(updatedSelectedRows);
        onRequisitionData(updatedSelectedRows);
    };
    const preventNegativeSign = (e) => {
        if (e.key === "-" || e.key === "+") {
            e.preventDefault();
        }
    };
    const handleQtyKeyDown = (e, index) => {
        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
            e.preventDefault();

            // Only rows that should be navigable
            const validRows = rows
                .map((row, rowIndex) => ({
                    row,
                    rowIndex
                }))
                .filter(
                    ({ row }) =>
                        Number(row.stock) > 0 &&
                        Number(row.unitPrice) > 0
                );

            // Find current row inside the filtered list
            const currentPosition = validRows.findIndex(
                ({ rowIndex }) => rowIndex === index
            );

            if (currentPosition === -1) {
                return;
            }

            let targetPosition;

            if (e.key === "ArrowDown") {
                targetPosition = currentPosition + 1;
            } else {
                targetPosition = currentPosition - 1;
            }

            // Prevent going outside the list
            if (
                targetPosition < 0 ||
                targetPosition >= validRows.length
            ) {
                return;
            }

            // Get the ORIGINAL rows index
            const targetIndex = validRows[targetPosition].rowIndex;

            // Focus after React/browser finishes current event
            requestAnimationFrame(() => {
                const nextInput = document.getElementById(
                    `issueQty-${targetIndex}`
                );

                if (nextInput) {
                    nextInput.focus();
                    nextInput.select();
                }
            });
        }

        // Prevent + and -
        else if (e.key === "-" || e.key === "+") {
            e.preventDefault();
        }
    };
    const startIssueTableResize = (e, column) => {
        e.preventDefault();

        const startX = e.clientX;
        const startWidth = issueColumnWidths[column];

        const handleMouseMove = (event) => {
            const newWidth = Math.max(
                50,
                startWidth + (event.clientX - startX)
            );

            setIssueColumnWidths(prev => ({
                ...prev,
                [column]: newWidth
            }));
        };

        const handleMouseUp = () => {
            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseup", handleMouseUp);
        };

        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
    };
    const IssueResizableHeader = ({ column, children }) => {
        return (
            <th
                style={{
                    width: `${issueColumnWidths[column]}px`,
                    minWidth: `${issueColumnWidths[column]}px`,
                    position: "relative"
                }}
            >
                {children}

                <span
                    className="resize-handle"
                    onMouseDown={(e) => startIssueTableResize(e, column)}
                />
            </th>
        );
    };
    return (
        <div>
            <div className='table-container p-2 mb-5' style={{ overflowX: 'auto', height: "400px" }}>
                <table>
                    <thead className="dynoTable">
                        <tr>

                            <IssueResizableHeader column="srNo">
                                Sr no
                            </IssueResizableHeader>

                            <IssueResizableHeader column="itemNo">
                                Item No
                            </IssueResizableHeader>

                            <IssueResizableHeader column="description">
                                Description
                            </IssueResizableHeader>
                            {/* 
                            <IssueResizableHeader column="specification">
                                Item Specs
                            </IssueResizableHeader> */}

                            <IssueResizableHeader column="reqQty">
                                Req QTY
                            </IssueResizableHeader>

                            <IssueResizableHeader column="issueQty">
                                Issue QTY
                            </IssueResizableHeader>

                            <IssueResizableHeader column="balQty">
                                Bal QTY
                            </IssueResizableHeader>

                            <IssueResizableHeader column="inventoryUOM">
                                Inventory UOM
                            </IssueResizableHeader>

                            <IssueResizableHeader column="inventoryQty">
                                Inventory Qty
                            </IssueResizableHeader>

                            <IssueResizableHeader column="stock">
                                Stock
                            </IssueResizableHeader>

                            <IssueResizableHeader column="unitPrice">
                                Unit Price
                            </IssueResizableHeader>

                            <IssueResizableHeader column="amount">
                                Amount
                            </IssueResizableHeader>

                            <IssueResizableHeader column="cgsAcc">
                                CGS Acc
                            </IssueResizableHeader>

                            <IssueResizableHeader column="cgsAccName">
                                CGS Acc Name
                            </IssueResizableHeader>

                            <IssueResizableHeader column="expDate">
                                exp Date
                            </IssueResizableHeader>

                        </tr>
                    </thead>

                    <tbody>
                        {rows
                            ?.map((row, originalIndex) => ({
                                row,
                                originalIndex
                            }))
                            .filter(({ row }) =>
                                Number(row.stock) > 0 &&
                                Number(row.unitPrice) > 0
                            )
                            .map(({ row, originalIndex }, index) => (
                                <tr key={row?._rowId || originalIndex}>

                                    {/* Sr No */}
                                    <td
                                        className="m-0 p-0"
                                        style={{
                                            width: `${issueColumnWidths.srNo}px`,
                                            minWidth: `${issueColumnWidths.srNo}px`
                                        }}
                                    >
                                        <input
                                            className="p-2"
                                            type="text"
                                            value={index + 1}
                                            disabled
                                            style={{
                                                width: "100%",
                                                boxSizing: "border-box"
                                            }}
                                        />
                                    </td>

                                    {/* Item No */}
                                    <td
                                        className="m-0 p-0"
                                        style={{
                                            width: `${issueColumnWidths.itemNo}px`,
                                            minWidth: `${issueColumnWidths.itemNo}px`
                                        }}
                                    >
                                        <input
                                            className="p-2"
                                            disabled
                                            value={row.ItemNo || ""}
                                            style={{
                                                width: "100%",
                                                boxSizing: "border-box"
                                            }}
                                        />
                                    </td>

                                    {/* Description */}
                                    <td
                                        className="m-0 p-0"
                                        style={{
                                            width: `${issueColumnWidths.description}px`,
                                            minWidth: `${issueColumnWidths.description}px`
                                        }}
                                    >
                                        <input
                                            className="p-2"
                                            disabled
                                            value={row.itemDescription || ""}
                                            style={{
                                                width: "100%",
                                                boxSizing: "border-box"
                                            }}
                                        />
                                    </td>

                                    {/* Specification */}
                                    {/* <td
                                        className="m-0 p-0"
                                        style={{
                                            width: `${issueColumnWidths.specification}px`,
                                            minWidth: `${issueColumnWidths.specification}px`
                                        }}
                                    >
                                        <input
                                            className="p-2"
                                            disabled
                                            value={row.specification || ""}
                                            style={{
                                                width: "100%",
                                                boxSizing: "border-box"
                                            }}
                                        />
                                    </td> */}

                                    {/* Req Qty */}
                                    <td
                                        className="m-0 p-0"
                                        style={{
                                            width: `${issueColumnWidths.reqQty}px`,
                                            minWidth: `${issueColumnWidths.reqQty}px`
                                        }}
                                    >
                                        <input
                                            className="p-2"
                                            disabled
                                            value={row.reqQty || 0}
                                            style={{
                                                width: "100%",
                                                boxSizing: "border-box"
                                            }}
                                        />
                                    </td>

                                    {/* Issue Qty */}
                                    <td
                                        className="m-0 p-0"
                                        style={{
                                            width: `${issueColumnWidths.issueQty}px`,
                                            minWidth: `${issueColumnWidths.issueQty}px`
                                        }}
                                    >
                                        <input
                                            id={`issueQty-${originalIndex}`}
                                            className="p-2"
                                            style={{
                                                width: "100%",
                                                boxSizing: "border-box"
                                            }}
                                            type="number"
                                            min={0}
                                            max={row.stock}
                                            value={row.enteredQty ?? ""}
                                            disabled={itemData?.eye === true}
                                            onWheel={(e) => e.target.blur()}
                                            onChange={(e) =>
                                                handleQtyChange(
                                                    originalIndex,
                                                    e.target.value
                                                )
                                            }
                                            onKeyDown={(e) =>
                                                handleQtyKeyDown(
                                                    e,
                                                    originalIndex
                                                )
                                            }
                                        />
                                    </td>

                                    {/* Bal Qty */}
                                    <td
                                        className="m-0 p-0"
                                        style={{
                                            width: `${issueColumnWidths.balQty}px`,
                                            minWidth: `${issueColumnWidths.balQty}px`
                                        }}
                                    >
                                        <input
                                            className="p-2"
                                            value={row.balQty || 0}
                                            disabled
                                            style={{
                                                width: "100%",
                                                boxSizing: "border-box"
                                            }}
                                        />
                                    </td>

                                    {/* Inventory UOM */}
                                    <td
                                        className="m-0 p-0"
                                        style={{
                                            width: `${issueColumnWidths.inventoryUOM}px`,
                                            minWidth: `${issueColumnWidths.inventoryUOM}px`
                                        }}
                                    >
                                        <input
                                            className="p-2"
                                            value={row.uom || ""}
                                            disabled
                                            style={{
                                                width: "100%",
                                                boxSizing: "border-box"
                                            }}
                                        />
                                    </td>

                                    {/* Inventory Qty */}
                                    <td
                                        className="m-0 p-0"
                                        style={{
                                            width: `${issueColumnWidths.inventoryQty}px`,
                                            minWidth: `${issueColumnWidths.inventoryQty}px`
                                        }}
                                    >
                                        <input
                                            className="p-2"
                                            value={row.invQty || 0}
                                            disabled
                                            style={{
                                                width: "100%",
                                                boxSizing: "border-box"
                                            }}
                                        />
                                    </td>

                                    {/* Stock */}
                                    <td
                                        className="m-0 p-0"
                                        style={{
                                            width: `${issueColumnWidths.stock}px`,
                                            minWidth: `${issueColumnWidths.stock}px`
                                        }}
                                    >
                                        <input
                                            className="p-2"
                                            disabled
                                            value={row.stock || 0}
                                            style={{
                                                width: "100%",
                                                boxSizing: "border-box"
                                            }}
                                        />
                                    </td>

                                    {/* Unit Price */}
                                    <td
                                        className="m-0 p-0"
                                        style={{
                                            width: `${issueColumnWidths.unitPrice}px`,
                                            minWidth: `${issueColumnWidths.unitPrice}px`
                                        }}
                                    >
                                        <input
                                            className="p-2"
                                            disabled
                                            value={
                                                Number(row.unitPrice || 0).toFixed(
                                                    currencyPrecision || 0
                                                )
                                            }
                                            style={{
                                                width: "100%",
                                                boxSizing: "border-box"
                                            }}
                                        />
                                    </td>

                                    {/* Amount */}
                                    <td
                                        className="m-0 p-0"
                                        style={{
                                            width: `${issueColumnWidths.amount}px`,
                                            minWidth: `${issueColumnWidths.amount}px`
                                        }}
                                    >
                                        <input
                                            className="p-2"
                                            disabled
                                            value={
                                                Number(row.amount || 0).toFixed(
                                                    currencyPrecision || 0
                                                )
                                            }
                                            style={{
                                                width: "100%",
                                                boxSizing: "border-box"
                                            }}
                                        />
                                    </td>

                                    {/* CGS Acc */}
                                    <td
                                        className="m-0 p-0"
                                        style={{
                                            width: `${issueColumnWidths.cgsAcc}px`,
                                            minWidth: `${issueColumnWidths.cgsAcc}px`
                                        }}
                                    >
                                        <input
                                            className="p-2"
                                            disabled
                                            value={row.cgsAcc || 0}
                                            style={{
                                                width: "100%",
                                                boxSizing: "border-box"
                                            }}
                                        />
                                    </td>

                                    {/* CGS Acc Name */}
                                    <td
                                        className="m-0 p-0"
                                        style={{
                                            width: `${issueColumnWidths.cgsAccName}px`,
                                            minWidth: `${issueColumnWidths.cgsAccName}px`
                                        }}
                                    >
                                        <input
                                            className="p-2"
                                            disabled
                                            value={row.cgsAccName || 0}
                                            style={{
                                                width: "100%",
                                                boxSizing: "border-box"
                                            }}
                                        />
                                    </td>

                                    {/* Exp Date */}
                                    <td
                                        className="m-0 p-0"
                                        style={{
                                            width: `${issueColumnWidths.expDate}px`,
                                            minWidth: `${issueColumnWidths.expDate}px`
                                        }}
                                    >
                                        <input
                                            className="p-2"
                                            type="date"
                                            value={row?.expDate || ""}
                                            disabled={itemData?.eye === true}
                                            onChange={(e) =>
                                                handleDateChange(
                                                    originalIndex,
                                                    e.target.value
                                                )
                                            }
                                            style={{
                                                width: "100%",
                                                boxSizing: "border-box"
                                            }}
                                        />
                                    </td>

                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
            <div className='d-flex justify-content-between boxs'>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Discount</div>
                    <div className='field'>---</div>
                </div>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Total Amount</div>
                    <div className='field'>{totalAmount.toFixed(currencyPrecision || 0) || "---"}</div>
                </div>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Total Discount</div>
                    <div className='field'>---</div>
                </div>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Total Vat</div>
                    <div className='field'>{totalVatAmount.toFixed(currencyPrecision || 0) || "---"}</div>
                </div>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Net Amount</div>
                    <div className='field'>{totalAmount.toFixed(currencyPrecision || 0) || "---"}</div>
                </div>
            </div>
        </div>
    );
};

export default ItemlistGrid;
